

import {
    GET_PROJECT_ACTION_TYPE
} from '../../sagas/project';

import opsub from '../common/opsub';
import { initialState as opsubInitialState} from '../common/opsub';

const initialState = {
    ...opsubInitialState
};

export default function createReducer(actionType) {

    const opsubReducer = opsub(actionType)

    return (state = initialState, action) => {
        switch (action.type) {
            case GET_PROJECT_ACTION_TYPE.SUCCESS:
                return {
                    ...initialState
                };
            default:
                return opsubReducer(state, action);
        }
    };
}
